export default __webpack_public_path__ + "static/media/FriCo-logo.50be1337.svg";